import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ValidateLoginMFACodeService } from '@modules/api/validate-login-mfa-code.service.generated';
import { CompleteLoginService } from '@modules/login-shared/services/complete-login.service';
import { CurrentLoginRequestService } from '@modules/login/services/current-login-request.service';

@Component({
    selector: 'app-login-enter-mfa-code',
    templateUrl: './login-enter-mfa-code.component.html',
    styleUrls: ['./login-enter-mfa-code.component.scss']
})
export class LoginEnterMFACodeComponent implements OnInit {
    public form!: FormGroup;
    public isExpiredRequest = false;
    public isInvalidCode = false;
    public isLockedOut = false;
    public countdownTimedOut = false;

    constructor(
        private _route: ActivatedRoute,
        private _formBuilder: FormBuilder,
        private _validateLoginMFACodeService: ValidateLoginMFACodeService,
        private _currentLoginRequestService: CurrentLoginRequestService,
        private _completeLoginService: CompleteLoginService,
    ) { }

    public ngOnInit(): void {
        this.form = this._formBuilder.group({
            'mfaCode': ['', [Validators.required, Validators.minLength(6)]]
        });
    }

    public onSubmit(): void {
        if (this.form.valid) {
            this.resetErrors();

            let loginRequest = this._currentLoginRequestService.getCurrentLoginRequest();
            this._validateLoginMFACodeService.validateLoginMFACode({
                loginMFACodeId: parseInt(this._route.snapshot.params['loginMFACodeId']),
                loginRequestId: loginRequest.id,
                loginRequestToken: loginRequest.token,
                mfaCode: this.form.get('mfaCode')!.value.trim(),
                encryptedRedirectUrl: sessionStorage.getItem('titaniaRedirect') || undefined,
            }).subscribe(result => {
                if (result.isLockedOut) {
                    this.isLockedOut = true;
                    this.isInvalidCode = false;
                } else if (result.isExpired) {
                    this.isExpiredRequest = true;
                } else if (result.isInvalidCode) {
                    this.isInvalidCode = true;
                } else {
                    this._completeLoginService.completeLogin({
                        deviceToken: result.deviceToken,
                        redirectHTML: result.redirectHtml,
                        userSession: result.userSession
                    });
                }
            });
        }
    }

    public onCountdownTimedOut(): void {
        this.countdownTimedOut = true;
    }

    private resetErrors(): void {
        this.isInvalidCode = false;
    }
}
